var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.32847 2.57953C4.00249 2.90551 4.00249 3.43209 4.32847 3.75808L7.57157 7.00118L4.32847 10.2443C4.00249 10.5703 4.00249 11.0968 4.32847 11.4228C4.65445 11.7488 5.18104 11.7488 5.50702 11.4228L9.34358 7.58627C9.66956 7.26029 9.66956 6.73371 9.34358 6.40772L5.50702 2.57117C5.1894 2.25354 4.65445 2.25354 4.32847 2.57953Z",
    fill: "#2b2b2b",
    stroke: "#2b2b2b",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronSide);
export default __webpack_public_path__ + "static/media/chevronSide.a39f091eda8d87b5418f5efa5a6edc1d.svg";
export { ForwardRef as ReactComponent };